import React, { useMemo } from "react";
import Style from "./index.module.scss";
import Header from "../../components/Header";
import { Breadcrumb, Row } from "antd";
import { Link, useParams } from "react-router-dom";
import DetailHeader from "../../components/Public/DetailHeader";
import useRequest from "../../utils/useRequest";
import { getEvaluation } from "../../service/evaluate";
import Item from "./Components/Item";
import { useSearchParam } from "react-use";

const Index = () => {
    const { id } = useParams();
    const isDeputy = useSearchParam("isDeputy"); // 默认过滤状态

    const [data, { loading }, reData] = useRequest(
        () => getEvaluation({ id, isDeputy }),
        {},
        [id, isDeputy]
    );
    const title = useMemo(() => {
        const evaluation = data?.evaluation;
        if (evaluation) {
            return `
                ${evaluation?.courseName} 
                ${evaluation?.courseNo} 
                ${evaluation?.courseSeq} 
                [${evaluation?.startTime} 至
                ${evaluation?.endTime}]
            `;
        } else {
            return "";
        }
    }, [data]);
    if (!data) {
        return null;
    }
    return (
        <div className={Style.root}>
            <Header style={{ marginBottom: 10 }} />
            <div className={Style.container}>
                <Breadcrumb separator=">">
                    <Breadcrumb.Item>
                        <Link to="/">首页</Link>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item>
                        <span>评价内容</span>
                    </Breadcrumb.Item>
                </Breadcrumb>
                <div className={Style.body}>
                    <DetailHeader
                        title={data.evaluation.courseName}
                        tips={title}>
                        <div className={Style.rank}>
                            {data?.score && parseInt(data?.score) > 0 && (
                                <span className={Style.yellow}>
                                    学评教成绩：{data.score}
                                </span>
                            )}
                            {/*{data?.scoreRank && (*/}
                            {/*    <span className={Style.yellow}>*/}
                            {/*        全校排名：{data.scoreRank}*/}
                            {/*    </span>*/}
                            {/*)}*/}
                        </div>
                    </DetailHeader>
                    <div className={Style.padding}>
                        <Row gutter={15} type="flex">
                            {data.resultArr.map(item => (
                                <Item key={item.key} data={item} />
                            ))}
                        </Row>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Index;
